import { render, staticRenderFns } from "./ChangePhoneForm.vue?vue&type=template&id=40ea8baa"
import script from "./ChangePhoneForm.vue?vue&type=script&lang=js"
export * from "./ChangePhoneForm.vue?vue&type=script&lang=js"
import style0 from "./ChangePhoneForm.vue?vue&type=style&index=0&id=40ea8baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports